import React, { useState, useMemo } from 'react'
import Loading from './Loading'
import useData from '../hooks/useData'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import Chart from './Chart'
import QueryBadge from './QueryBadge'
import { format, subDays } from 'date-fns'

const SearchConsole = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const snippet = useData('snippet/' + id)
    const article = useData('article/' + (snippet.isReady && snippet.data.target___article_id), [snippet.isReady])
    snippet.isReady && console.log(snippet.data)
    const [date, setDate] = useState([subDays(new Date(), 90), new Date()])
    const site = useData('site/' + (snippet.isReady && snippet.data.target___site_id) + '?scope=seo', [snippet.isReady])

    const scdata = useData(
        'google/search_console?site_id=' +
            (snippet.isReady && snippet.data.target___site_id) +
            '&dimensions[0]=date&query=' +
            (snippet.isReady && snippet.data.keywords) +
            '&start_date=' +
            format(date[0], 'yyyy-MM-dd') +
            '&end_date=' +
            format(date[1], 'yyyy-MM-dd'),
        [snippet.isReady]
    )
    const { isLoading: scIsLoading, data: scdatasite } = useData(
        'google/search_console?site_id=' +
            (snippet.isReady && snippet.data.target___site_id) +
            '&dimensions[0]=date&start_date=' +
            format(date[0], 'yyyy-MM-dd') +
            '&end_date=' +
            format(date[1], 'yyyy-MM-dd'),
        [snippet.isReady]
    )

    // console.log({ scdata })
    console.log(scdata.isReady && scdata.data)

    const chartData = useMemo(
        () =>
            (scdata.isReady &&
                scdata.data
                    .reduce((acc, item) => {
                        acc.push({ name: item.keys[0], clicks: item.clicks, impressions: item.impressions })
                        return acc
                    }, [])
                    .sort((a, b) => (a.name.localeCompare(b.name) && 1) || -1)) ||
            [],
        [scdata]
    )

    return (
        <React.Fragment>
            {(site.isReady && article.isReady && snippet.isReady && (
                <React.Fragment>
                    <DateRangePicker onChange={setDate} value={date} className="float-right" locale="fr" />
                    <small>{site.data.label}</small>
                    <h2>
                        {article.data.title}
                        <br />
                        <QueryBadge>{snippet.data.keywords}</QueryBadge>
                    </h2>
                    <p>created on {snippet.data.created_at}</p>
                    {(scIsLoading && <Loading text="Loading impressions and clicks" />) || null}
                    {(!scIsLoading && scdatasite && (
                        <>
                            <h2>Impressions and clicks</h2>
                            <p>{site.url}</p>
                            <div className="my-5">
                                <Chart data={chartData} />
                            </div>
                        </>
                    )) ||
                        null}
                </React.Fragment>
            )) || <Loading text="Loading site data" />}
        </React.Fragment>
    )
}

export default SearchConsole
